/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_HOLDERS_DETAIL: {
    offset: 0,
    size: 12,
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.holdersDetailPage.holdersDetail',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_HOLDERS_DETAIL' },
      },
    },
    GET_HOLDERS_DETAIL: {
      invoke: {
        id: 'getHoldersDetail',
        src: 'getHoldersDetail',
        onDone: {
          target: 'RENDER_HOLDERS_DETAIL',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_HOLDERS_DETAIL_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_HOLDERS_DETAIL: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_HOLDERS_DETAIL',
        },
      },
    },
    RENDER_HOLDERS_DETAIL_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
